// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2yGti","image":"Header_image__1PdZj","name":"Header_name__1s5PQ","info":"Header_info__1x947","infoRow":"Header_infoRow__1iTGu"};